module.exports = __webpack_public_path__ + "static/media/Dayton Pickering.8e64bb05.png";